import React from 'react';

import gtm from '@periodica/analytics/gtm';
import { Counter, HelpButton, NotificationMark } from '@periodica/ui-kit';
import * as ActionList from '@periodica/ui-kit/actionList';
import { useUseDesk } from '@periodica/usedesk';

import * as styles from './HelpMenuButton.module.css';

export function HelpMenuButton() {
  const { load, open, error, isReady, messageCount } = useUseDesk();
  return (
    <ActionList.Provider
      placement="top-end"
      setOpen={(menuIsOpen) => {
        if (menuIsOpen) {
          load();
          gtm.logEvent({ name: 'event_site_help_center' });
        }
      }}
    >
      <ActionList.Trigger render={<HelpButton loading={!isReady} className={styles.helpButton} />}>
        {messageCount !== 0 ? (
          <NotificationMark variant="critical" className={styles.topRight} />
        ) : null}
      </ActionList.Trigger>

      <ActionList.ActionList style={{ zIndex: '9999' }}>
        {!error && (
          <ActionList.Item
            onClick={() => {
              open();
              gtm.logEvent({ name: 'event_site_support_chat_open' });
            }}
            addition={messageCount !== 0 && <Counter variant="critical" value={messageCount} />}
          >
            Чат с поддержкой
          </ActionList.Item>
        )}
        <ActionList.ExternalLink
          // через open('tg') можно открыть телеграмм чат, но там нельзя настроить точную ссылку
          // ссылка берется из интеграции канала, которой нет в настройках
          // так как привязка происходит через токен внутри телеги
          // ссылка на доку https://api.usedocs.ru/article/49595
          href="https://telegram.me/periodicasupport_bot?start=site_support_widget"
          onClick={() => gtm.logEvent({ name: ' event_site_tg_chat_open' })}
        >
          Telegram
        </ActionList.ExternalLink>

        <ActionList.ExternalLink
          href="https://max.ru/id7743125098_bot"
          onClick={() => gtm.logEvent({ name: 'event_site_max_chat_open' })}
        >
          Max
        </ActionList.ExternalLink>

        <ActionList.Divider />

        <ActionList.ExternalLink
          href="https://periodica.press/faq/"
          onClick={() => gtm.logEvent({ name: 'event_site_docs-search_click' })}
        >
          Частые вопросы
        </ActionList.ExternalLink>
      </ActionList.ActionList>
    </ActionList.Provider>
  );
}
